export const ADVOCATE_PREJOIN_PAYLOAD_KEY = "advocate-prejoin-payload";
export const ADVOCATE_LOBBY_PAYLOAD_KEY = "advocate-lobby-payload";
export const PUBLIC_ADVOCATE_POPUP_KEY = "public-advocate-popup";

export const readStoredPayload = <T,>(key: string): T | null => {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    window.localStorage.removeItem(key);
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

const popupFeatures = () => {
  const width = Math.min(1600, Math.max(1100, window.screen.availWidth - 160));
  const height = Math.min(900, Math.max(760, window.screen.availHeight - 120));
  const left = Math.max(0, Math.round((window.screen.availWidth - width) / 2));
  const top = Math.max(0, Math.round((window.screen.availHeight - height) / 2));

  return [
    "popup=yes",
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    "resizable=yes",
    "scrollbars=yes",
  ].join(",");
};

const openTabWithPayload = (
  path: string,
  key: string,
  payload: unknown,
  features?: string,
) => {
  window.localStorage.setItem(key, JSON.stringify(payload));
  const url = new URL(path, window.location.origin);
  const opened = window.open(url.toString(), "_blank", features);
  opened?.focus();
  return Boolean(opened);
};

export const openAdvocatePrejoinTab = (payload: unknown) =>
  openTabWithPayload(
    "/meeting?source=advocate-dashboard",
    ADVOCATE_PREJOIN_PAYLOAD_KEY,
    payload,
    popupFeatures(),
  );

export const openAdvocateLobbyFullscreenTab = (payload: unknown) =>
  openTabWithPayload(
    "/advocate-lobby?fullscreen=1",
    ADVOCATE_LOBBY_PAYLOAD_KEY,
    payload,
  );
